import React, { useState, useEffect } from 'react';
import { Mail, MessageSquare, Smartphone, Send, Clock } from 'lucide-react';
import useDidFetch from '../../custom_hooks/useDidfetch';
import api from '../../services/ApiService';
import { ENDPOINTS } from '../../constant/ApiEndpoints';
import toast from 'react-hot-toast';
import TextInput from '../InputComponent/TextInput';
import SelectInput from '../InputComponent/SelectInput';
import TextAreaInput from '../InputComponent/TextAreaInput';

const channels = [
    { id: 'email', name: 'Email', icon: Mail },
    // { id: 'SMS', name: 'SMS', icon: MessageSquare },
    { id: 'app', name: 'App Push', icon: Smartphone },
];

const NotificationComposer = ({ onSend, isLoading }) => {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [targetGroup, setTargetGroup] = useState('all');
    const [specificUser, setSpecificUser] = useState('');
    const [targetAudience, setTargetAudience] = useState('All Members');
    const [selectedChannels, setSelectedChannels] = useState(['App Push']);
    const [scheduleTime, setScheduleTime] = useState('');

    const [members, setMembers] = useState([]);
    const [trainers, setTrainers] = useState([]);

    const handleChannelToggle = (channelId) => {
        setSelectedChannels(prev =>
            prev.includes(channelId)
                ? prev.filter(id => id !== channelId)
                : [...prev, channelId]
        );
    };

    useEffect(() => {
        // Reset form
        setTitle('');
        setMessage('');
        setTargetGroup('all');
        setSpecificUser('');
        setSelectedChannels(['app']);
        setScheduleTime('');
    }, [isLoading]);

    const handleSubmit = (e) => {
        if (!title) {
            toast.error("Title is required.");
            return;
        }

        if (!message) {
            toast.error("Message is required.");
            return;
        }

        if (selectedChannels.length === 0) {
            toast.error("Please select at least one channel.");
            return;
        }
        let targetAudience = 'all';
        if (targetGroup === 'user' && specificUser) {
            // targetAudience = users.find(u => u.id === specificUser)?.name || 'user';
        } else if (targetGroup === 'trainers' && specificUser) {
            // targetAudience = users.find(u => u.id === specificUser)?.name || 'trainers';
        } else if (targetGroup !== 'all') {
            toast.error('Please select a specific person for the chosen target group.');
            return;
        }
        onSend({
            title,
            message,
            targetGroup,
            specificUser,
            channels: selectedChannels,
            scheduleTime: scheduleTime || null,
        });

        setTitle('');
        setMessage('');
        setTargetGroup('all');
        setSpecificUser('');
        setSelectedChannels(['App Push']);
        setScheduleTime('');
    };
    const runOnce = useDidFetch();

    useEffect(() => {
        runOnce(() => {
            getTrainers();
            getMembers();
            getAllUser();
        });
    }, []);

    const getTrainers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/trainer`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setTrainers(result?.users ?? []);
            }
        } catch (error) {
            console.error("trainer error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
     const getAllUser = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(ENDPOINTS.getUser);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) { 
                const trainers = result?.users.filter(u => u.role?.name == 'trainer');
                console.log(trainers);
                setTrainers(trainers);
            }
        } catch (error) {
            console.error("user get error:", error);
        } finally {
            // setIsLoading(false);
        }
    }
    const getMembers = async () => {
        try {
            // setIsLoading(true);
            const response = await api.get(`${ENDPOINTS.getUserByRole}/member`);
            const result = response?.data;
            console.log(response);
            if (response.status === 200) {
                setMembers(result?.users ?? []);
            }
        } catch (error) {
            console.error("getMembers error:", error);
        } finally {
            // setIsLoading(false);
        }
    }

    const getTargetUsers = () => {
        if (targetGroup === 'user') {
            return members;
        }
        if (targetGroup === 'trainers') {
            return trainers;
        }
        return [];
    };

    return (
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
            <h3 className="text-xl font-bold text-gray-800 font-display mb-4">New Message</h3>
            <div className="space-y-4">
                <TextInput label={"Title"} type="text" value={title} onChange={e => setTitle(e.target.value)} isRequired={true} />
                <TextAreaInput label={"Message"} value={message} onChange={e => setMessage(e.target.value)} rows="5" isRequired={true} />
                <SelectInput label={"Target Group"} value={targetGroup} onChange={e => { setTargetGroup(e.target.value); setSpecificUser(''); }}>
                    <option value="all">All Members</option>
                    <option value="user">Specific Member</option>
                    <option value="trainers">Specific Trainer</option>
                </SelectInput>
                {(targetGroup === 'user' || targetGroup === 'trainers') && (
                    <SelectInput label={"Select Person"} value={specificUser} onChange={e => setSpecificUser(e.target.value)}>
                        <option value="" disabled>Select a person...</option>
                        {getTargetUsers().map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                    </SelectInput>)}

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Channels</label>
                    <div className="flex gap-2">
                        {channels.map(channel => (
                            <button key={channel.id} onClick={() => handleChannelToggle(channel.id)} className={`flex-1 flex items-center justify-center gap-2 p-3 rounded-lg border-2 transition-all ${selectedChannels.includes(channel.id) ? 'bg-red-50 border-brand-red text-brand-red' : 'bg-gray-100 border-transparent text-gray-500 hover:bg-gray-200'}`}>
                                <channel.icon size={20} />
                                <span className="font-medium text-sm">{channel.name}</span>
                            </button>
                        ))}
                    </div>
                </div>
                {/* <div>
                    <label className="block text-sm font-medium text-gray-700">Schedule Time (Optional)</label>
                    <input type="datetime-local" value={scheduleTime} onChange={e => setScheduleTime(e.target.value)} className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-brand-red focus:border-brand-red" />
                </div> */}
                <div className="pt-2 flex justify-end gap-3">
                    {/* <button onClick={() => handleSubmit(true)} disabled={!scheduleTime} className="flex items-center gap-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
                        <Clock size={18} /> Schedule
                    </button> */}
                    <button disabled={isLoading} onClick={() => handleSubmit(false)} className="flex items-center gap-2 px-4 py-2 bg-brand-red text-white rounded-lg hover:bg-red-600">
                        <Send size={18} /> {isLoading ? 'Loading' : 'Send Now'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationComposer;
